<template>
  <van-popup get-container="#app" class="pop-content" v-model="chancePopShow" :close-on-click-overlay="false" position="bottom" :style="{ height: '100%' }">
    <div class="chance-all">
      <div class="chance-bottom">
        <div class="chance-scan chance-way">
          <div class="scan-way">
            <div class="bosch-code">扫博世产品码（{{scanGainCount || 0}}/2）</div>
            <div class="scan-tips">成功扫码10次，抽签次数+1</div>
          </div>
          <div class="chance-btn draw-btn" @click="startScan()" v-if="scanGainCount < 2 && scanGainCount >=0">去扫码</div>
          <div class="no-chance-btn draw-btn" v-else>已领完</div>
        </div>
        <div class="chance-pay chance-way">
          <div class="pay-way">
            <div class="bosch-points">使用88积分兑换（{{pointGainCount || 0}}/3）</div>
            <div class="scan-tips">支付88易加积分，抽签次数+1</div>
          </div>
          <div class="chance-btn draw-btn" @click="startPay()" v-if="pointGainCount < 3 && pointGainCount >= 0">去兑换</div>
          <div class="no-chance-btn draw-btn" v-else>已领完</div>
          <!-- <div class="chance-btn" @click="getChance()">领取</div> -->
        </div>
      </div>
      <div class="pop-close" @click="closePop()"></div>
    </div>
    <van-popup class="comfirm-pop" v-model="surePay" :close-on-click-overlay="false">
      <div class="comfirm-box">
        <div class="comfirm-title">您确定兑换吗？</div>
        <div class="comfirm-btns">
          <div class="cancel-btn btn" @click="surePay = false">取消</div>
          <div class="sure-btn btn" @click="handleSure()">确定</div>
        </div>
      </div>
    </van-popup>
  </van-popup>
</template>
<script>
import { Notify } from 'vant'
import activityApi from '@/api/activity'
export default {
  props: ['pointGainCount', 'scanGainCount'],
  data () {
    return {
      chancePopShow: false,
      surePay: false,
      isPay: false
    }
  },
  methods: {
    popAppear () {
      this.chancePopShow = true
    },
    closePop () {
      this.chancePopShow = false
      this.$emit('closePop')
    },

    startPay () {
      this.surePay = true
      this.isPay = false
    },
    handleSure () {
      if (!this.isPay) {
        activityApi.pointGain().then(res => {
          if (res.data.resultCode === '0') {
            Notify({ type: 'success', message: '兑换成功！' })
            this.$parent.getDrawCount()
          }
          this.surePay = false
          this.isPay = true
        }).catch(err => {
          console.log(err)
          this.surePay = false
          this.isPay = true
        })
      }
    },

    // 扫码 跳转至大乐透
    startScan () {
      this.$router.push({ path: '/lottery/home' })
    }
  }
}
</script>
<style lang="less" scoped>
.pop-content {
  background-color: rgba(0, 0, 0, .1);
}
.chance-all {
  width: 350px;
  height: 216px;
  margin: 150px auto;
  padding-top: 80px;
  background-image: url('../../../assets/images/new-year/chance.png');
  background-size: 100%;
  background-repeat: no-repeat;
}
.chance-bottom {
  width: 70%;
  height: 130px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  box-sizing: border-box;
  .chance-way {
    width: 100%;
    height: 50px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .bosch-code,.bosch-points {
      font-size: 16px;
    }
    .scan-tips {
      font-size: 12px;
      margin-top: 5px;
    }
    .draw-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 50px;
      height: 22.5px;
      color: #ffffff;
    }
    .chance-btn {
      background-image: url('../../../assets/images/new-year/chance-btn.png');
      background-size: 100%;
    }
    .no-chance-btn {
      background-image: url('../../../assets/images/new-year/no-chance.png');
      background-size: 100%;
    }
  }
  .chance-scan {
    margin-bottom: 10px;
  }
}
.pop-close {
  width: 28px;
  height: 28px;
  margin: 40px auto 0;
  background-image: url('../../../assets/images/new-year/close.png');
  background-size: 100%;
  background-repeat: no-repeat;
  pointer-events: auto;
}
.comfirm-pop {
  border-radius: 10px;
}
.comfirm-box {
  width: 280px;
  height: 100px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border-radius: 20px;
  .comfirm-title {
    width: 100%;
    height: 50px;
    text-align: center;
    line-height: 50px;
  }
  .comfirm-btns {
    width: 200px;
    height: 50px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    .btn {
      width: 80px;
      height: 36px;
      text-align: center;
      line-height: 34px;
      color: #ffffff;
      background-repeat: no-repeat;
      background-size: 100%;
    }
    .cancel-btn {
      background-image: url('../../../assets/images/new-year/no-chance.png');
    }
    .sure-btn {
      background-image: url('../../../assets/images/new-year/chance-btn.png');
    }
  }
}
</style>
